"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var errors_1 = require("@ledgerhq/errors");
var logic_1 = require("./logic");
var typhonjs_1 = require("@stricahq/typhonjs");
var errors_2 = require("./errors");
var errors_3 = require("../../errors");
var networks_1 = require("./networks");
var buildSubAccounts_1 = require("./buildSubAccounts");
var js_estimateMaxSpendable_1 = __importDefault(require("./js-estimateMaxSpendable"));
var js_buildTransaction_1 = require("./js-buildTransaction");
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, useAllAmount, cardanoResources, networkParams, estimatedFees, amount, totalSpent, tokenAccount, tokensToSend, assetId, _a, policyId, assetName, _b, minTransactionAmount, e_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                errors = {};
                warnings = {};
                useAllAmount = !!t.useAllAmount;
                cardanoResources = a.cardanoResources;
                networkParams = (0, networks_1.getNetworkParameters)(a.currency.id);
                if (a.pendingOperations.length > 0) {
                    throw new errors_3.AccountAwaitingSendPendingOperations();
                }
                estimatedFees = t.fees || new bignumber_js_1.BigNumber(0);
                amount = t.amount;
                totalSpent = estimatedFees;
                tokenAccount = t.subAccountId && a.subAccounts
                    ? a.subAccounts.find(function (a) {
                        return a.id === t.subAccountId;
                    })
                    : undefined;
                tokensToSend = [];
                if (!t.subAccountId) return [3 /*break*/, 1];
                // Token transaction
                if (!tokenAccount || tokenAccount.type !== "TokenAccount") {
                    throw new Error("TokenAccount not found");
                }
                assetId = (0, buildSubAccounts_1.decodeTokenCurrencyId)(tokenAccount.token.id).assetId;
                _a = (0, buildSubAccounts_1.decodeTokenAssetId)(assetId), policyId = _a.policyId, assetName = _a.assetName;
                amount = t.useAllAmount ? tokenAccount.balance : t.amount;
                totalSpent = amount;
                tokensToSend = [
                    {
                        policyId: policyId,
                        assetName: assetName,
                        amount: amount
                    },
                ];
                return [3 /*break*/, 5];
            case 1:
                if (!t.useAllAmount) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, js_estimateMaxSpendable_1["default"])({ account: a, transaction: t })];
            case 2:
                _b = _c.sent();
                return [3 /*break*/, 4];
            case 3:
                _b = amount;
                _c.label = 4;
            case 4:
                // ADA transaction
                amount = _b;
                totalSpent = amount.plus(estimatedFees);
                _c.label = 5;
            case 5:
                minTransactionAmount = typhonjs_1.utils.calculateMinUtxoAmount(tokensToSend, new bignumber_js_1.BigNumber(cardanoResources.protocolParams.lovelacePerUtxoWord), false);
                if (!t.fees) {
                    errors.fees = new errors_1.FeeNotLoaded();
                }
                if (!t.recipient) {
                    errors.recipient = new errors_1.RecipientRequired();
                }
                else if (!(0, logic_1.isValidAddress)(t.recipient, networkParams.networkId)) {
                    errors.recipient = new errors_1.InvalidAddress();
                }
                if (!!amount.gt(0)) return [3 /*break*/, 6];
                errors.amount = useAllAmount
                    ? new errors_2.CardanoNotEnoughFunds()
                    : new errors_1.AmountRequired();
                return [3 /*break*/, 11];
            case 6:
                if (!(!t.subAccountId && amount.lt(minTransactionAmount))) return [3 /*break*/, 7];
                errors.amount = new errors_2.CardanoMinAmountError("", {
                    amount: minTransactionAmount.div(1e6).toString()
                });
                return [3 /*break*/, 11];
            case 7:
                if (!(tokenAccount
                    ? totalSpent.gt(tokenAccount.balance)
                    : totalSpent.gt(a.balance))) return [3 /*break*/, 8];
                errors.amount = new errors_1.NotEnoughBalance();
                return [3 /*break*/, 11];
            case 8:
                _c.trys.push([8, 10, , 11]);
                return [4 /*yield*/, (0, js_buildTransaction_1.buildTransaction)(a, t)];
            case 9:
                _c.sent();
                return [3 /*break*/, 11];
            case 10:
                e_1 = _c.sent();
                if (e_1.message.toLowerCase() === "not enough ada" ||
                    e_1.message.toLowerCase() === "not enough tokens") {
                    errors.amount = new errors_2.CardanoNotEnoughFunds();
                }
                throw e_1;
            case 11: return [2 /*return*/, Promise.resolve({
                    errors: errors,
                    warnings: warnings,
                    estimatedFees: estimatedFees,
                    amount: amount,
                    totalSpent: totalSpent
                })];
        }
    });
}); };
exports["default"] = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map